export default __webpack_public_path__ + "static/media/instagram.6f449485.svg";